import IWaveStat from '@/constants/integrations/IWaveStat';

const IWaveFilterDefaultValues = {
  [IWaveStat.SCORE]: '',
  [IWaveStat.CAPACITY]: '',
  [IWaveStat.PROPENSITY]: '',
  [IWaveStat.AFFINITY]: '',
  [IWaveStat.PLANNED_GIVING]: '',
};

export default IWaveFilterDefaultValues;
